import React, { useState } from 'react';
import './RecipeBookCatalog.css';

const SECTIONS = [
  {
    id: 'cafes',
    num: 'Section I',
    sub: 'Grand Parlors & Salons',
    title: 'Cafés & Coffee Houses',
    navLabel: 'I · Cafés',
    books: [
      {
        id: 'cafe-de-flore',
        vol: 'Vol. I',
        location: 'Saint-Germain',
        title: 'Café de Flore',
        subtitle: 'Paris Registry, 1887',
        count: '142 Formulations',
        bgColor: '#8B3A3E',
        borderColor: '#5E2225',
        ribbonColor: '#B8575B',
        ribbonBorder: '#F3DCAD',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'coffee'
      },
      {
        id: 'caffe-florian',
        vol: 'Vol. II',
        location: 'Piazza San Marco',
        title: 'Caffè Florian',
        subtitle: 'Venetian Folio, 1720',
        count: '186 Formulations',
        bgColor: '#3E5C6E',
        borderColor: '#273F4D',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'star'
      },
      {
        id: 'cafe-central',
        vol: 'Vol. III',
        location: 'Herrengasse',
        title: 'Café Central',
        subtitle: 'Viennese Roasters, 1876',
        count: '204 Formulations',
        bgColor: '#B87333',
        borderColor: '#864C1B',
        ribbonColor: '#D48943',
        ribbonBorder: '#FFF2D6',
        textColor: '#FFFDF8',
        goldColor: '#FFF3DA',
        svgType: 'circle'
      },
      {
        id: 'cafe-procope',
        vol: 'Vol. IV',
        location: "Rue de l'Ancienne",
        title: 'Café Procope',
        subtitle: 'Enlightenment Salon, 1686',
        count: '119 Formulations',
        bgColor: '#4D6B55',
        borderColor: '#324B39',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'flame'
      }
    ]
  },
  {
    id: 'restaurants',
    num: 'Section II',
    sub: 'Dining Rooms & Bistros',
    title: 'Restaurants & Haute Cuisine',
    navLabel: 'II · Restaurants',
    books: [
      {
        id: 'lambroisie',
        vol: 'Vol. V',
        location: 'Place des Vosges',
        title: "L'Ambroisie",
        subtitle: 'Haute Cuisine Codex, 1986',
        count: '260 Formulations',
        bgColor: '#E8DFC8',
        borderColor: '#C7BA9F',
        ribbonColor: '#B87333',
        ribbonBorder: '#7A5B27',
        textColor: '#2C221A',
        goldColor: '#7A5B27',
        subTextColor: '#5D462A',
        badgeColor: '#6B5338',
        svgType: 'crown'
      },
      {
        id: 'le-grand-vefour',
        vol: 'Vol. VI',
        location: 'Galeries Beaujolais',
        title: 'Le Grand Véfour',
        subtitle: 'Palais-Royal Table, 1784',
        count: '310 Formulations',
        bgColor: '#63455E',
        borderColor: '#452D41',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'layers'
      },
      {
        id: 'rules-1798',
        vol: 'Vol. VII',
        location: 'Maiden Lane',
        title: 'Rules 1798',
        subtitle: 'Sovereign Grill & Game, Covent Garden',
        count: '175 Formulations',
        bgColor: '#C48B58',
        borderColor: '#945F31',
        ribbonColor: '#8B4443',
        ribbonBorder: '#FFF0D0',
        textColor: '#FFFDF9',
        goldColor: '#FFF5DE',
        svgType: 'star'
      },
      {
        id: 'antica-pesa',
        vol: 'Vol. VIII',
        location: 'Trastevere',
        title: 'Antica Pesa',
        subtitle: 'Roman Registry, 1922',
        count: '198 Formulations',
        bgColor: '#3A5C61',
        borderColor: '#243F43',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'compass'
      }
    ]
  },
  {
    id: 'hotels',
    num: 'Section III',
    sub: 'Grand Lodgings & Manors',
    title: 'Hotels & Palatial Inns',
    navLabel: 'III · Hotels & Inns',
    books: [
      {
        id: 'grand-hotel-des-bains',
        vol: 'Vol. IX',
        location: 'Lido di Venezia',
        title: 'Grand Hôtel des Bains',
        subtitle: 'Belle Époque Registry, 1900',
        count: '155 Formulations',
        bgColor: '#456272',
        borderColor: '#2D4452',
        ribbonColor: '#B87333',
        ribbonBorder: '#F3DCAD',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'globe'
      },
      {
        id: 'bean-there',
        vol: 'Vol. X',
        location: 'The Strand, London',
        title: 'Bean There',
        subtitle: 'Sovereign Suites & Banquets, 1889',
        count: '340 Formulations',
        bgColor: '#C98246',
        borderColor: '#945520',
        textColor: '#FFFDF9',
        goldColor: '#FFF5DE',
        svgType: 'building'
      },
      {
        id: 'hotel-danieli',
        vol: 'Vol. XI',
        location: 'Riva degli Schiavoni',
        title: 'Hotel Danieli',
        subtitle: 'Doge Quarters & Banquets, 1822',
        count: '162 Formulations',
        bgColor: '#6A4B67',
        borderColor: '#4A3047',
        ribbonColor: '#9C4F4E',
        ribbonBorder: '#F3DCAD',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'star'
      },
      {
        id: 'palace-hotel-st-moritz',
        vol: 'Vol. XII',
        location: 'Engadin Alpine',
        title: 'Palace Hotel St. Moritz',
        subtitle: 'Alpine Grand Cuisine, 1896',
        count: '224 Formulations',
        bgColor: '#506F5A',
        borderColor: '#334A3C',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'sun'
      }
    ]
  },
  {
    id: 'bakeries',
    num: 'Section IV',
    sub: 'Hearth Ovens & Wild Leavens',
    title: 'Artisanal Bakeries & Bakeshops',
    navLabel: 'IV · Bakeries',
    books: [
      {
        id: 'the-hearth-and-gilt',
        vol: 'Vol. XIII',
        location: 'Flanders Hearth',
        title: 'The Hearth & Gilt',
        subtitle: 'Bruges Guild Master, 1745',
        count: '92 Formulations',
        bgColor: '#B87333',
        borderColor: '#864C1B',
        ribbonColor: '#D48943',
        ribbonBorder: '#FFF0D0',
        textColor: '#FFFDF8',
        goldColor: '#FFF3DA',
        svgType: 'circle'
      },
      {
        id: 'poilane-woodfire',
        vol: 'Vol. XIV',
        location: 'Rue du Cherche-Midi',
        title: 'Poilâne Woodfire Codex',
        subtitle: 'Stoneground Levain, 1932',
        count: '115 Formulations',
        bgColor: '#DDD2B8',
        borderColor: '#BCAC8E',
        textColor: '#2C221A',
        goldColor: '#7A5B27',
        subTextColor: '#5D462A',
        badgeColor: '#6B5338',
        svgType: 'flame'
      },
      {
        id: 'demel-court-bakeshop',
        vol: 'Vol. XV',
        location: 'Kohlmarkt Imperial',
        title: 'Demel Court Bakeshop',
        subtitle: 'Purveyors to the Habsburgs, 1786',
        count: '240 Formulations',
        bgColor: '#934547',
        borderColor: '#682A2C',
        ribbonColor: '#B8575B',
        ribbonBorder: '#F3DCAD',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'star'
      },
      {
        id: 'maison-kayser',
        vol: 'Vol. XVI',
        location: 'Rue Monge',
        title: 'Maison Kayser Sourdough',
        subtitle: 'Liquid Ferment Manual, 1996',
        count: '136 Formulations',
        bgColor: '#55725D',
        borderColor: '#374E3E',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'star'
      }
    ]
  },
  {
    id: 'gelato',
    num: 'Section V',
    sub: 'Granitas, Sorbetiers & Cremas',
    title: 'Ice Parlors & Gelaterias',
    navLabel: 'V · Ice Parlors',
    books: [
      {
        id: 'corona-ducale-florence',
        vol: 'Vol. XVII',
        location: 'Palazzo Vecchio',
        title: 'Corona Ducale Florence',
        subtitle: 'Buontalenti Cream Canon, 1565',
        count: '84 Formulations',
        bgColor: '#664661',
        borderColor: '#472D43',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'sun'
      },
      {
        id: 'vivoli-gelato',
        vol: 'Vol. XVIII',
        location: 'Via Isola delle Stinche',
        title: 'Vivoli Gelato Archives',
        subtitle: 'Tuscan Crema & Zabaione, 1930',
        count: '108 Formulations',
        bgColor: '#4B6856',
        borderColor: '#31483A',
        ribbonColor: '#C5A059',
        ribbonBorder: '#FFF0D0',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'globe'
      },
      {
        id: 'berthillon-sorbetier',
        vol: 'Vol. XIX',
        location: 'Île Saint-Louis',
        title: 'Berthillon Sorbetier Codex',
        subtitle: 'Pur Fruit Glaciers, 1954',
        count: '96 Formulations',
        bgColor: '#415E6E',
        borderColor: '#283F4C',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'compass'
      },
      {
        id: 'gran-caffe-rivoire',
        vol: 'Vol. XX',
        location: 'Piazza della Signoria',
        title: 'Gran Caffè Rivoire',
        subtitle: 'Cioccolata da Bere & Gelato, 1872',
        count: '114 Formulations',
        bgColor: '#C07E42',
        borderColor: '#8E4F1B',
        ribbonColor: '#8B4443',
        ribbonBorder: '#FFF0D0',
        textColor: '#FFFDF9',
        goldColor: '#FFF5DE',
        svgType: 'star'
      }
    ]
  },
  {
    id: 'confectionery',
    num: 'Section VI',
    sub: 'Pralines, Ganache & Dragées',
    title: 'Confectionery & Chocolatiers',
    navLabel: 'VI · Chocolatiers',
    books: [
      {
        id: 'maison-cacao-brussels',
        vol: 'Vol. XXI',
        location: 'Grand-Place',
        title: 'Maison Cacao Brussels',
        subtitle: 'Belgian Praline Registry, 1912',
        count: '164 Formulations',
        bgColor: '#E5DCBE',
        borderColor: '#C2B491',
        ribbonColor: '#8C6D37',
        ribbonBorder: '#594018',
        textColor: '#2C221A',
        goldColor: '#7A5B27',
        subTextColor: '#5D462A',
        badgeColor: '#6B5338',
        svgType: 'globe'
      },
      {
        id: 'confiserie-sprungli',
        vol: 'Vol. XXII',
        location: 'Paradeplatz Zürich',
        title: 'Confiserie Sprüngli',
        subtitle: 'Luxemburgerli & Truffles, 1836',
        count: '210 Formulations',
        bgColor: '#3D5A6C',
        borderColor: '#273F4D',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'star'
      },
      {
        id: 'boissier-patisserie',
        vol: 'Vol. XXIII',
        location: 'Boulevard des Capucines',
        title: 'Boissier Pâtisserie & Praline',
        subtitle: 'Marrons Glacés & Bonbons, 1827',
        count: '148 Formulations',
        bgColor: '#88363B',
        borderColor: '#5E1E23',
        ribbonColor: '#B8575B',
        ribbonBorder: '#F3DCAD',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'flame'
      },
      {
        id: 'debauve-and-gallais',
        vol: 'Vol. XXIV',
        location: 'Rue des Saints-Pères',
        title: 'Debauve & Gallais',
        subtitle: 'Chocolats des Rois de France, 1800',
        count: '172 Formulations',
        bgColor: '#5C405A',
        borderColor: '#3D283B',
        textColor: '#FFFBF3',
        goldColor: '#F3DCAD',
        svgType: 'star'
      }
    ]
  }
];

function renderSvgIcon(type, iconColor) {
  const style = { width: 20, height: 20, display: 'block', color: iconColor };

  switch (type) {
    case 'coffee':
      return (
        <svg style={style} fill="currentColor" viewBox="0 0 24 24">
          <path d="M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4v-2z" />
        </svg>
      );
    case 'star':
      return (
        <svg style={style} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2L9.5 7.5L3.5 8.5L8 12.5L6.5 18.5L12 15.5L17.5 18.5L16 12.5L20.5 8.5L14.5 7.5L12 2Z" />
        </svg>
      );
    case 'circle':
      return (
        <svg style={style} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 3C7 3 3 7 3 12C3 17 7 21 12 21C17 21 21 17 21 12C21 7 17 3 12 3ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z" />
        </svg>
      );
    case 'flame':
      return (
        <svg style={style} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 23C16.14 23 19.5 19.64 19.5 15.5C19.5 12.38 17.5 9.38 15.5 7C14.7 6.05 13.9 5.15 13.3 4.2C13 3.75 12.5 3 12 2C11.5 3 11 3.75 10.7 4.2C10.1 5.15 9.3 6.05 8.5 7C6.5 9.38 4.5 12.38 4.5 15.5C4.5 19.64 7.86 23 12 23Z" />
        </svg>
      );
    case 'crown':
      return (
        <svg style={style} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 3L1 9L12 15L21 10.09V17H23V9M5 13.18V17.18L12 21L19 17.18V13.18L12 17L5 13.18Z" />
        </svg>
      );
    case 'layers':
      return (
        <svg style={style} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24">
          <path d="M12 2L2 7L12 12L22 7L12 2Z" />
          <path d="M2 17L12 22L22 17" />
          <path d="M2 12L12 17L22 12" />
        </svg>
      );
    case 'compass':
      return (
        <svg style={style} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm1 14.93V17a1 1 0 0 1-2 0v-.07A7.003 7.003 0 0 1 5.07 11H7a1 1 0 0 1 0-2H5.07A7.003 7.003 0 0 1 11 5.07V7a1 1 0 0 1 2 0V5.07A7.003 7.003 0 0 1 18.93 11H17a1 1 0 0 1 0 2h1.93A7.003 7.003 0 0 1 13 16.93z" />
        </svg>
      );
    case 'globe':
      return (
        <svg style={style} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
        </svg>
      );
    case 'building':
      return (
        <svg style={style} stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24">
          <path d="M3 21h18M3 7v14M21 7v14M6 7V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3M9 10h6M9 14h6M9 18h6" />
        </svg>
      );
    case 'sun':
      return (
        <svg style={style} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm-1 18h2v2h-2v-2z" />
        </svg>
      );
    default:
      return (
        <svg style={style} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2L9.5 7.5L3.5 8.5L8 12.5L6.5 18.5L12 15.5L17.5 18.5L16 12.5L20.5 8.5L14.5 7.5L12 2Z" />
        </svg>
      );
  }
}

export default function RecipeBookCatalog({ onSelectBook }) {
  const [activeSection, setActiveSection] = useState('');

  const scrollToSection = (id) => {
    setActiveSection(id);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="rbc-container">
      {/* Header */}
      <header className="rbc-header">
        <div className="rbc-header-inner">
          <h1 className="rbc-title rbc-font-cinzel rbc-gold-emboss">
            Recipe Library
          </h1>
          <p className="rbc-subtitle rbc-font-sans">
            Archival Ledgers &amp; Culinary Tomes of Historic Establishments
          </p>

          {/* Navigation Bar */}
          <nav className="rbc-nav rbc-font-sans">
            {SECTIONS.map((sec, idx) => (
              <React.Fragment key={sec.id}>
                <a
                  className={`rbc-nav-item ${activeSection === sec.id ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(sec.id);
                  }}
                  href={`#${sec.id}`}
                >
                  {sec.navLabel}
                </a>
                {idx < SECTIONS.length - 1 && <span className="rbc-nav-bullet">•</span>}
              </React.Fragment>
            ))}
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main className="rbc-main">
        {SECTIONS.map((sec) => (
          <section key={sec.id} id={sec.id} className="rbc-section">
            {/* Section Header */}
            <div className="rbc-section-header">
              <div>
                <div className="rbc-section-meta">
                  <span className="rbc-section-tag">{sec.num}</span>
                  <span style={{ color: 'rgba(197, 160, 89, 0.6)', fontSize: '12px' }}>❖</span>
                  <span className="rbc-section-subtag">{sec.sub}</span>
                </div>
                <h2 className="rbc-section-title">{sec.title}</h2>
              </div>
              <div className="rbc-section-count">
                {sec.books.length} Classified Tomes
              </div>
            </div>

            {/* Grid of Books */}
            <div className="rbc-grid">
              {sec.books.map((book) => {
                const borderOuterColor = book.goldColor ? `${book.goldColor}66` : 'rgba(243, 220, 173, 0.4)';
                const borderInnerColor = book.goldColor ? `${book.goldColor}40` : 'rgba(243, 220, 173, 0.25)';
                const iconColor = book.goldColor || '#F3DCAD';

                return (
                  <article
                    key={book.id}
                    onClick={() => onSelectBook && onSelectBook(book)}
                    className="rbc-book-card"
                    style={{
                      backgroundColor: book.bgColor,
                      borderLeftColor: book.borderColor
                    }}
                  >
                    <div className="rbc-spine-line"></div>
                    <div className="rbc-paper-edge"></div>

                    {/* Bookmark ribbon */}
                    {book.ribbonColor && (
                      <div
                        className="rbc-bookmark"
                        style={{
                          height: '2.75rem',
                          backgroundColor: book.ribbonColor,
                          borderBottom: `2px solid ${book.ribbonBorder || 'rgba(243, 220, 173, 0.6)'}`
                        }}
                      />
                    )}

                    {/* Frames */}
                    <div
                      className="rbc-border-outer"
                      style={{ borderColor: borderOuterColor }}
                    />
                    <div
                      className="rbc-border-inner"
                      style={{ borderColor: borderInnerColor }}
                    />

                    {/* Top info */}
                    <div className="rbc-book-top">
                      <span
                        className="rbc-book-vol"
                        style={{ color: book.goldColor || '#F3DCAD' }}
                      >
                        {book.vol}
                      </span>
                      <div
                        className="rbc-book-location"
                        style={{ color: book.subTextColor || `${book.goldColor || '#F3DCAD'}DC` }}
                      >
                        {book.location}
                      </div>
                    </div>

                    {/* Center info */}
                    <div className="rbc-book-center">
                      <div
                        className="rbc-book-icon"
                        style={{ color: iconColor }}
                      >
                        {renderSvgIcon(book.svgType, iconColor)}
                      </div>
                      <h3
                        className="rbc-book-title"
                        style={{ color: book.textColor || '#FFFBF3' }}
                      >
                        {book.title}
                      </h3>
                      <span
                        className="rbc-book-subtitle"
                        style={{ color: book.goldColor || 'rgba(243, 220, 173, 0.9)' }}
                      >
                        {book.subtitle}
                      </span>
                    </div>

                    {/* Bottom info */}
                    <div className="rbc-book-bottom">
                      <span
                        className="rbc-book-count"
                        style={{ color: book.badgeColor || `${book.goldColor || '#F3DCAD'}CC` }}
                      >
                        {book.count}
                      </span>
                    </div>
                  </article>
                );
              })}
            </div>
          </section>
        ))}
      </main>

      {/* Footer */}
      <footer className="rbc-footer">
        <div className="rbc-footer-inner">
          <div style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.35em', color: '#9A773E', fontWeight: 600 }}>
            The Private Compendiums of Europe &amp; Beyond
          </div>
          <div style={{ color: '#4A3B2C', fontWeight: 500 }}>
            THE PRIVATE ARCHIVE • CULINARY MANUSCRIPTS • 24 CLASSIFIED TOMES
          </div>
        </div>
      </footer>
    </div>
  );
}
